import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import TableContainer from "../../../../components/Common/TableContainer";
import "../../../../assets/css/individual-cart.css";
import { formatDateTime } from "../../../../utils/dayjs";

const IndividualCart = () => {
const baseurl = process.env.REACT_APP_BASE_URL;
  const imgurl = process.env.REACT_APP_IMAGE_URL;

  const [cartData, setCartData] = useState([]);
  const [pagination, setPagination] = useState({});
  const [statusFilter, setStatusFilter] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
      const fetchCarts = async () => {
        try {
          setLoading(true);
          const res = await fetch(`${baseurl}/admin/customer/individuals/carts`);
          const data = await res.json();
  
          if (data.success) {
            setCartData(data.data);
            setPagination(data.pagination);
          } else {
            setCartData([]);
          }
        } catch (err) {
          console.error("Fetch carts error:", err);
        } finally {
          setLoading(false);
        }
      };
  
fetchCarts();
    }, [baseurl]);

    const filteredData = useMemo(() => {
  if (!statusFilter) return cartData;

  return cartData.filter(
    item => item.status?.toLowerCase() === statusFilter.toLowerCase()
  );
}, [cartData, statusFilter]);

  const columns = useMemo(
    () => [
      {
        Header: "Cart ID",
        accessor: "id",
      filterable: true,
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "	Cart No",
        accessor: "cart_no",
        filterable: true,
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "Company Name",
        accessor: "company_name",
        filterable: true,
      },
      {
        Header: "Customer Name",
        accessor: "customer_name",
        filterable: true,
      },
      {
        Header: "Cart Value",
        accessor: "cart_value",
        filterable: true,
      },
      
      {
        Header: "Created Date",
        accessor: "created_at",
        filterable: true,
        Cell: ({ value }) => (
                <span>{formatDateTime(value)}</span>
              ),
      },

      {
        Header: "Updated Date",
        accessor: "updated_at",
        filterable: true,
        Cell: ({ value }) => (
                <span>{formatDateTime(value)}</span>
              ),
      },
      {
        Header: "Order Status",
        accessor: "status",
        filterable: true,
        Cell: ({ value }) => (
          <Badge color={value === "Converted" ? "success" : "danger"}>
            {value.charAt(0).toUpperCase() + value.slice(1)}
          </Badge>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => {
          const status = row.original.status;
          const isExpired = status === "expired";
          return (
            <div className="d-flex gap-3 align-items-center">
              <Link
                to={`/manage-request/cart/individual-customers/cart-list/${row.original.cart_no}`}
                className={`text-success ${isExpired ? "disabled-link" : ""}`}
                aria-disabled={isExpired}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit Cart
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  document.title = "Individual Customer Cart | Admin";

  return (
    <>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs
            title="Cart"
            breadcrumbItem="Individual Customer Cart List"
          />
          
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="status-filter-wrapper">
                <select name="filter"
                  className="status-filter"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
        <option value="">All</option>
        <option value="Active">Active</option>
        <option value="Converted">Converted</option>
        <option value="Expired">Expired</option>
      </select>
    </div>
                  <TableContainer
                    columns={columns}
                    data={filteredData}
                    isGlobalFilter={true}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default IndividualCart;
